import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { EmergenciaPesv, EmergenciaPesvService } from '../../../../shared/services/emergencia-pesv.service';
import { EquipoEmergenciaPesvItem, EquiposEmergenciaPesvService } from '../../../../shared/services/equipos-emergencia-pesv.service';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Utils } from '../../../../shared/utils/Utils';

@Component({
  selector: 'app-emergencia',
  templateUrl: './emergencia.component.html',
  styleUrls: ['./emergencia.component.scss']
})
export class EmergenciaComponent implements OnInit {
  emergencias: EmergenciaPesv[] = [];
  form: FormGroup;
  formEditar: FormGroup;
  cargando = false;
  guardando = false;
  editandoModal: EmergenciaPesv | null = null;
  tabActiva = 1;
  filtro: string = '';
  filtroEstado: number | null = null;
  emergenciasFiltradas: EmergenciaPesv[] = [];
  pageSize = 10;
  page = 1;
  opcionesEquiposEmergencia: EquipoEmergenciaPesvItem[] = [];
  maxFechaHoy = this.obtenerFechaHoyIso();


  constructor(
    private emergenciaService: EmergenciaPesvService,
    private equiposEmergenciaService: EquiposEmergenciaPesvService,
    private fb: FormBuilder,
    private modalService: NgbModal
  ) {
    this.form = this.crearFormulario();
    this.formEditar = this.crearFormulario();
  }

  private crearFormulario(): FormGroup {
    return this.fb.group({
      numero_colaboradores: [null, [Validators.required, Validators.min(1)]],
      descripcion_equipos: ['', Validators.required],
      simulacro: [null, Validators.required],
      ultimo_simulacro: ['', [Validators.required, this.fechaNoFuturaValidator()]],
      tipo_simulacro: [null, Validators.required],
      estado: [1, Validators.required]
    });
  }

  private fechaNoFuturaValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const valor = control.value;
      if (!valor) {
        return null;
      }

      const fecha = new Date(valor);
      if (Number.isNaN(fecha.getTime())) {
        return { fechaInvalida: true };
      }

      fecha.setHours(0, 0, 0, 0);
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      return fecha > hoy ? { fechaFutura: true } : null;
    };
  }

  private obtenerFechaHoyIso(): string {
    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, '0');
    const dd = String(hoy.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  ngOnInit() {
    this.cargarEmergencias();
    this.cargarOpcionesEquiposEmergencia();
  }

  private cargarOpcionesEquiposEmergencia(): void {
    this.equiposEmergenciaService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta)
          ? respuesta
          : Array.isArray(respuesta?.equipos_emergencia_pesv)
            ? respuesta.equipos_emergencia_pesv
            : Array.isArray(respuesta?.data)
              ? respuesta.data
              : [];

        this.opcionesEquiposEmergencia = lista
          .map((item: any) => ({
            id: Number(item?.id || 0),
            descripcion: String(item?.descripcion || '').trim(),
            estado: Number(item?.estado ?? 1),
          }))
          .filter((item: EquipoEmergenciaPesvItem) => !!item.id && !!item.descripcion && item.estado === 1);
      },
      error: () => {
        this.opcionesEquiposEmergencia = [];
      }
    });
  }

  cargarEmergencias() {
    this.cargando = true;
    this.emergenciaService.getAll().subscribe({
      next: (data) => {
        this.emergencias = data;
        this.aplicarFiltro();
        this.cargando = false;
      },
      error: () => {
        this.cargando = false;
      }
    });
  }

  aplicarFiltro(): void {
    const termino = (this.filtro || '').trim().toLowerCase();
    this.page = 1;
    this.emergenciasFiltradas = this.emergencias.filter(e => {
      const coincideEstado = this.filtroEstado === null || e.estado === this.filtroEstado;
      const coincideBusqueda =
        String(e.numero_colaboradores || '').toLowerCase().includes(termino) ||
        String(e.descripcion_equipos || '').toLowerCase().includes(termino) ||
        (e.simulacro === 1 ? 'sí' : e.simulacro === 0 ? 'no' : '').includes(termino) ||
        (e.ultimo_simulacro || '').toLowerCase().includes(termino) ||
        (e.tipo_simulacro === 1 ? 'ejercicio práctico' : e.tipo_simulacro === 2 ? 'simulación de escritorio' : '').toLowerCase().includes(termino);
      return coincideEstado && coincideBusqueda;
    });
  }

  guardar() {
    if (this.form.invalid) return;
    this.guardando = true;
    const data = this.form.value;
    this.emergenciaService.create(data).subscribe({
      next: () => {
        this.cargarEmergencias();
        this.form.reset({ estado: 1 });
        Swal.fire('Éxito', 'Emergencia guardada correctamente.', 'success');
      },
      error: () => {
        Swal.fire('Error', 'No se pudo guardar la emergencia.', 'error');
      },
      complete: () => { this.guardando = false; }
    });
  }


  abrirModalEditar(content: any, emergencia: EmergenciaPesv) {
    this.editandoModal = emergencia;
    this.formEditar.reset({ estado: emergencia.estado ?? 1 });
    this.formEditar.patchValue(emergencia);

    const modalRef = this.modalService.open(content, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
    });

    modalRef.result.finally(() => {
      this.editandoModal = null;
      this.formEditar.reset({ estado: 1 });
    });
  }

  guardarEdicionEmergencia(modal: any) {
    if (!this.editandoModal) return;
    if (this.formEditar.invalid) {
      this.formEditar.markAllAsTouched();
      return;
    }
    this.guardando = true;
    const data = this.formEditar.value;
    this.emergenciaService.update(this.editandoModal.id!, data).subscribe({
      next: () => {
        this.cargarEmergencias();
        modal.close();
        this.editandoModal = null;
        this.formEditar.reset({ estado: 1 });
        Swal.fire('Éxito', 'Emergencia actualizada correctamente.', 'success');
      },
      error: () => {
        Swal.fire('Error', 'No se pudo actualizar la emergencia.', 'error');
      },
      complete: () => { this.guardando = false; }
    });
  }


  eliminar(id: number) {
    Swal.fire({
      title: '¿Inactivar emergencia?',
      text: 'La emergencia será marcada como inactiva.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, inactivar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.emergenciaService.changeEstado(id, 0).subscribe({
          next: () => {
            this.cargarEmergencias();
            Swal.fire('Inactivado', 'Emergencia inactivada correctamente.', 'success');
          },
          error: () => {
            Swal.fire('Error', 'No se pudo inactivar la emergencia.', 'error');
          }
        });
      }
    });
  }

  activar(id: number) {
    Swal.fire({
      title: '¿Activar emergencia?',
      text: 'La emergencia será marcada como activa.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, activar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.emergenciaService.changeEstado(id, 1).subscribe({
          next: () => {
            this.cargarEmergencias();
            Swal.fire('Activado', 'Emergencia activada correctamente.', 'success');
          },
          error: () => {
            Swal.fire('Error', 'No se pudo activar la emergencia.', 'error');
          }
        });
      }
    });
  }

  cancelar() {
    this.form.reset({ estado: 1 });
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
}
